import { jsx } from "react/jsx-runtime";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { validateTidalLicense } from "../../base/index.js";
function TrendingUp(props) {
  return /* @__PURE__ */ jsx(
    TrendingUpIcon,
    {
      "data-testid": "TrendingUp",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "TrendingUp",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
TrendingUp.tidalIconMeta = {
  categories: "miscellaneous",
  name: "TrendingUp"
};
validateTidalLicense();
export {
  TrendingUp
};
//# sourceMappingURL=TrendingUp.js.map
